import { AlertColor } from "@mui/material";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type SliceState = {
  message: Message;
  notification: Notification;
};

export interface MessageOptions {
  link?: string;
  timeOut?: number;
}

export interface Message {
  type: AlertColor;
  text: string;
  options?: MessageOptions;
}

export interface NotificationLink {
  text: string;
  href: string;
}

export interface Notification {
  title: string;
  text: string;
  confirmText?: string;
  links?: Record<string, NotificationLink>;
}

const initialState = {
  message: {
    type: "info" as AlertColor,
    text: "",
  },
  notification: {
    title: "",
    text: "",
  },
};

export const messageSlice = createSlice({
  name: "message",
  initialState: initialState as SliceState,
  reducers: {
    setMessage: (state, action: PayloadAction<Message>) => {
      state.message = action.payload;
    },
    unsetMessage: (state) => {
      state.message = initialState.message;
    },
    setNotification: (state, action: PayloadAction<Notification>) => {
      state.notification = action.payload;
    },
    unsetNotification: (state) => {
      state.notification.title = "";
      state.notification.text = "";
      state.notification.confirmText = undefined;
      state.notification.links = undefined;
    },
  },
});

export const messageReducer = messageSlice.reducer;
export const messageActions = messageSlice.actions;
